import { mergeClasses } from "@fluentui/react-components";
import { useStyle } from "./style";
import { IconSize } from "./types";

export const InteractionIconContainer: React.FC<{
	icon: JSX.Element;
	iconSize: IconSize;
}> = ({ icon, iconSize }) => {
	const classes = useStyle();

	return (
		<div
			className={mergeClasses(
				classes.composedIcon,
				classes.iconContainer,
				iconSize == IconSize.Large && classes.largeSizeIcon
			)}
		>
			{icon}
		</div>
	);
};
